export async function register() {
  if (process.env.NODE_ENV !== 'production') return console.warn('DEV - not registering service worker');
  if (!('serviceWorker' in navigator)) return;

  const { Workbox } = await import('workbox-window');

  const wb = new Workbox('/service-worker.js');
  await wb.register();
}

export async function unregister() {
  if (!('serviceWorker' in navigator)) return;

  await navigator.serviceWorker.ready.then((registration) => registration.unregister());
}
